export default __webpack_public_path__ + "static/media/ag_6.a3cf8d57.wav";